import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/home.vue'

const childrenList = [{
  path: '/home',
  component: () => import('../views/homePage.vue')
},
{
  path: 'test',
  component: () => import('../views/test.vue')
},
{
  path: '/more/:id',
  component: () => import('../views/morePage.vue')
},
{
  path: '/gitMail',
  component: () => import('../views/gitMail.vue')
},
{
  path: '/gitIdea',
  component: () => import('../views/gitIdea.vue')
},
{
  path: '/detail/:id',
  component: () => import("../views/detail.vue")
}]

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/home',
    component: HomeView,
    children: childrenList
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  }
]


const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
